import React from 'react';
import { Checkbox as PdcCheckbox } from '@mzc-pdc/ui';

export const Checkbox = (props: { checked: boolean }) => (
  <PdcCheckbox color={'greySecondary'} checked={props.checked} />
);
